/* Satori redesign — homepage motion (native scroll + GSAP, no Lenis) */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var root = document.querySelector('.satori-home');

  function cursor(){
    if(!fine || reduce || !root) return;
    var cur=document.querySelector('.satori-cursor'), ring=document.querySelector('.satori-cursor-ring');
    if(!cur||!ring) return;
    var mx=innerWidth/2,my=innerHeight/2,rx=mx,ry=my;
    document.addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;cur.style.left=mx+'px';cur.style.top=my+'px';});
    (function loop(){rx+=(mx-rx)*0.18;ry+=(my-ry)*0.18;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(loop);})();
    root.querySelectorAll('a,button,.satori-mag').forEach(function(el){
      el.addEventListener('mouseenter',function(){root.classList.add('hovering');});
      el.addEventListener('mouseleave',function(){root.classList.remove('hovering');});
    });
    root.querySelectorAll('.satori-mag').forEach(function(el){
      el.addEventListener('mousemove',function(e){var r=el.getBoundingClientRect();el.style.transform='translate('+(e.clientX-(r.left+r.width/2))*0.2+'px,'+(e.clientY-(r.top+r.height/2))*0.3+'px)';});
      el.addEventListener('mouseleave',function(){el.style.transform='';});
    });
  }

  function motion(){
    if(!window.gsap){ // fallback: reveal everything
      document.querySelectorAll('.satori-reveal').forEach(function(e){e.style.opacity=1;e.style.transform='none';});
      document.querySelectorAll('.satori-hero h1 .ln span').forEach(function(s){s.style.transform='none';});
      document.querySelectorAll('.satori-hero .lede,.satori-hero .satori-cta').forEach(function(e){e.style.opacity=1;});
      return;
    }
    if(reduce){
      document.querySelectorAll('.satori-reveal').forEach(function(e){e.style.opacity=1;e.style.transform='none';});
      document.querySelectorAll('.satori-hero h1 .ln span').forEach(function(s){s.style.transform='none';});
      document.querySelectorAll('.satori-hero .lede,.satori-hero .satori-cta').forEach(function(e){e.style.opacity=1;});
      return;
    }
    if(window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);
    /* hero intro */
    var tl=gsap.timeline({delay:0.12});
    tl.to('.satori-hero h1 .ln span',{y:0,duration:1.1,ease:'power4.out',stagger:0.12})
      .to('.satori-hero .lede, .satori-hero .satori-cta',{opacity:1,duration:0.9,ease:'power3.out',stagger:0.1},'-=0.5');
    if(window.ScrollTrigger){
      gsap.to('.satori-hero__media',{yPercent:16,ease:'none',scrollTrigger:{trigger:'.satori-hero',start:'top top',end:'bottom top',scrub:true}});
      gsap.to('.satori-story__media img',{yPercent:14,ease:'none',scrollTrigger:{trigger:'.satori-story',start:'top bottom',end:'bottom top',scrub:true}});
      gsap.utils.toArray('.satori-reveal').forEach(function(el){
        gsap.to(el,{opacity:1,y:0,duration:1,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 90%'}});
      });
    }
  }

  function ethos(){
    var h=document.getElementById('satori-ethos'); if(!h||reduce||!fine) return;
    var walk=document.createTreeWalker(h,NodeFilter.SHOW_TEXT,null), nodes=[];
    while(walk.nextNode())nodes.push(walk.currentNode);
    nodes.forEach(function(n){
      var frag=document.createDocumentFragment();
      n.textContent.split(/(\s+)/).forEach(function(tok){
        if(tok==='')return;
        if(/^\s+$/.test(tok)){frag.appendChild(document.createTextNode(tok));return;}
        var w=document.createElement('span');w.style.display='inline-block';w.style.whiteSpace='nowrap';
        tok.split('').forEach(function(c){var s=document.createElement('span');s.className='ch';s.textContent=c;w.appendChild(s);});
        frag.appendChild(w);
      });
      n.parentNode.replaceChild(frag,n);
    });
    h.addEventListener('mousemove',function(e){
      h.querySelectorAll('.ch').forEach(function(s){
        var r=s.getBoundingClientRect(),dx=e.clientX-(r.left+r.width/2),dy=e.clientY-(r.top+r.height/2),d=Math.sqrt(dx*dx+dy*dy);
        if(d<120){var f=1-d/120;s.style.transform='translateY('+(-f*14)+'px)';s.style.color='var(--usucha)';}else{s.style.transform='';s.style.color='';}
      });
    });
    h.addEventListener('mouseleave',function(){h.querySelectorAll('.ch').forEach(function(s){s.style.transform='';s.style.color='';});});
  }

  function init(){ cursor(); motion(); ethos(); }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* horizontal ritual + subscribe toggle */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    var track = document.querySelector('.satori-htrack');
    if(track && window.gsap && window.ScrollTrigger && !reduce && window.innerWidth > 860){
      var dist = track.scrollWidth - window.innerWidth;
      if(dist > 0){
        gsap.to(track,{x:-dist,ease:'none',scrollTrigger:{trigger:'.satori-ritual',start:'top top',end:'+='+dist,scrub:0.6,pin:'.satori-ritual__pin',anticipatePin:1,invalidateOnRefresh:true}});
      }
    }
    document.querySelectorAll('.satori-subopt').forEach(function(o){
      o.addEventListener('click',function(){
        document.querySelectorAll('.satori-subopt').forEach(function(x){x.classList.remove('sel');x.setAttribute('aria-pressed','false');});
        o.classList.add('sel'); o.setAttribute('aria-pressed','true');
      });
    });
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
